<!--
 * @Description:
 * @Author: Xyyyyyy
 * @Date: 2023-06-25 18:23:29
 * @LastEditors: Xyyyyyy
 * @LastEditTime: 2023-06-26 16:23:17
-->
<template>
  <div class="layout_main">
    <RouterView />
  </div>
</template>
<script setup>
// 错误捕获 ———— 忽略错误，不记录进日志
const e = window.error
window.onerror = function (errorMessage, scriptURI, lineNumber, columnNumber, error) {
  try {
    if (errorMessage === 'ResizeObserver loop limit exceeded') {
      throw new Error(errorMessage)
    }
  } catch (e) {}
}
</script>
<style lang="less">
</style>
